import React from "react";
import { Container } from "@shared/ui/container";
import styles from "../rules-content/rules-content.module.scss";

const PersonalDataPoliticsContent: React.FC = () => {
    return (
        <Container>
            <div className={styles.RulesHeaderContent}>
                <h1>Политика обработки персональных данных</h1>
            </div>
            <div className={styles.RulesContent}>
                <h2>1. Общие положения</h2>
                <p>
                    Настоящая Политика обработки персональных данных (далее — Политика) разработана
                    в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных
                    данных» и действует в отношении всех персональных данных, которые ООО «ГОНЗО»
                    (ОГРН 1197746350240, ИНН 9731042980, Юр.адрес: 121354, Москва г, Можайское ш,
                    дом 34А, этаж 2, помещение I (далее— Оператор) может получить от субъектов
                    персональных данных — физических лиц, в рамках осуществления своей деятельности
                    как взаимодействие с информацией о продаже транспортных средств, размещенной на
                    сайте, а также предоставляет возможность размещения на сайте собственных
                    объявлений о продаже транспортных средств.
                </p>

                <h2>2. Основные понятия</h2>
                <ul>
                    <li>
                        <strong>Персональные данные</strong> — любая информация, относящаяся к прямо
                        или косвенно определённому или определяемому физическому лицу (субъекту
                        персональных данных).
                    </li>
                    <li>
                        <strong>Оператор</strong> — ООО «ГОНЗО», организующее и (или) осуществляющее
                        обработку персональных данных.
                    </li>
                    <li>
                        <strong>Обработка персональных данных</strong> — любое действие (операция)
                        или совокупность действий с персональными данными.
                    </li>
                    <li>
                        <strong>Автоматизированная обработка</strong> — обработка с использованием
                        средств вычислительной техники.
                    </li>
                    <li>
                        <strong>Обезличивание</strong> — действия, в результате которых невозможно
                        определить принадлежность персональных данных конкретному субъекту.
                    </li>
                </ul>

                <h2>3. Принципы и цели обработки персональных данных</h2>
                <ol>
                    <li>
                        Обработка персональных данных осуществляется на законной, справедливой и
                        прозрачной основе.
                    </li>
                    <li>
                        Целями обработки являются:
                        <ul>
                            <li>предоставление услуг в сфере автомобильной тематики;</li>
                            <li>
                                ведение договорных отношений с партнёрами, клиентами и сотрудниками;
                            </li>
                            <li>осуществление кадрового и бухгалтерского учёта;</li>
                            <li>исполнение обязанностей, предусмотренных законодательством РФ;</li>
                            <li>улучшение качества цифровых продуктов LIKVI.</li>
                        </ul>
                    </li>
                </ol>

                <h2>4. Персональные данные, обрабатываемые Оператором</h2>
                <ol>
                    <li>
                        Оператор обрабатывает следующие категории данных:
                        <ul>
                            <li>фамилия, имя, отчество;</li>
                            <li>контактные данные (телефон, электронная почта);</li>
                            <li>паспортные данные;</li>
                            <li>ИНН, СНИЛС;</li>
                            <li>информация о трудовой деятельности;</li>
                            <li>данные о местоположении и IP-адрес;</li>
                            <li>иные сведения, необходимые для достижения целей обработки.</li>
                        </ul>
                    </li>
                    <li>
                        Оператор не осуществляет обработку специальных категорий персональных данных
                        (в том числе данных о расовой принадлежности, политических взглядах,
                        религиозных или философских убеждениях, состоянии здоровья, интимной жизни),
                        за исключением случаев, когда такая обработка осуществляется на основании
                        письменного согласия субъекта персональных данных и в соответствии с
                        требованиями законодательства Российской Федерации.
                    </li>
                </ol>

                <h2>5. Правовые основания обработки</h2>
                <ul>
                    <li>согласие субъекта персональных данных;</li>
                    <li>необходимость исполнения договора;</li>
                    <li>исполнение обязанностей, возложенных законодательством;</li>
                    <li>
                        легитимный интерес Оператора (например, обеспечение безопасности и качества
                        сервиса).
                    </li>
                </ul>

                <h2>6. Условия обработки и хранения</h2>
                <ol>
                    <li>
                        Оператор обеспечивает конфиденциальность и безопасность при обработке
                        персональных данных.
                    </li>
                    <li>
                        Хранение персональных данных осуществляется в течение сроков, установленных
                        законодательством РФ и (или) внутренними регламентами, но не более 5 лет
                        после окончания срока действия договора или до момента отзыва согласия
                        субъектом персональных данных, если иное не предусмотрено федеральным
                        законом.
                    </li>
                    <li>
                        Передача данных третьим лицам допускается только при наличии законных
                        оснований или согласия субъекта.
                    </li>
                    <li>
                        Трансграничная передача персональных данных за пределы территории Российской
                        Федерации не осуществляется.
                    </li>
                </ol>

                <h2>7. Права субъекта персональных данных</h2>
                <p>Субъект имеет право:</p>
                <ul>
                    <li>получать информацию о своих персональных данных;</li>
                    <li>требовать уточнения, блокировки или уничтожения данных;</li>
                    <li>отозвать согласие на обработку;</li>
                    <li>обжаловать действия Оператора в уполномоченные органы или в суд.</li>
                </ul>

                <h2>8. Обеспечение безопасности персональных данных</h2>
                <ol>
                    <li>
                        Оператор принимает организационные и технические меры по защите персональных
                        данных от неправомерного доступа, уничтожения, изменения, блокирования,
                        копирования, распространения.
                    </li>
                    <li>
                        Ответственность за обеспечение безопасности возлагается на назначенных
                        сотрудников LIKVI.
                    </li>
                </ol>

                <h2>9. Заключительные положения</h2>
                <ol>
                    <li>
                        Политика является общедоступным документом и размещается на официальном
                        сайте LIKVI.
                    </li>
                    <li>
                        Изменения в Политику вносятся по мере необходимости, актуальная версия
                        всегда доступна на сайте.
                    </li>
                </ol>
            </div>
        </Container>
    );
};

export default PersonalDataPoliticsContent;